class ProgressHolder {
  constructor() {
    this.progress = null
  }

  setProgress(progress) {
    this.progress = progress
    return progress
  }

  get() {
    return this.progress
  }
}

export default new ProgressHolder()
